import { render } from "./EvangelioModal.vue?vue&type=template&id=b8b43b0e&scoped=true"
import script from "./EvangelioModal.vue?vue&type=script&lang=js"
export * from "./EvangelioModal.vue?vue&type=script&lang=js"

import "./EvangelioModal.vue?vue&type=style&index=0&id=b8b43b0e&scoped=true&lang=css"

import exportComponent from "/Users/q/Documents/projects/religious-app/admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b8b43b0e"]])

export default __exports__